<template>
    <div>
        <el-table
                v-loading="loading"
                :data="referrals">
            <div slot="empty">
                <span v-if="!loading">{{ $t('el.table.emptyText') }}</span>
            </div>

            <el-table-column
                    prop="id"
                    label="ID">
            </el-table-column>

            <el-table-column
                    prop="name"
                    :label="$t('referral')">
            </el-table-column>

            <el-table-column
                    prop="created_at"
                    :label="$t('created_at')">
                <template slot-scope="scope">
                    {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-count="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        name: "ReferralList",
        data () {
            return {
                referrals: [],
                page: 1,
                total_pages: 0,
                loading: true
            };
        },
        created () {
            this.getReferrals();
        },
        methods: {
            getReferrals () {
                this.loading = true;
                this.$axios.get('/referrals?' + qs.stringify({ page: this.page, 'per-page': '25' }, { encode: false })).then((res) => {
                    this.referrals = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                    this.loading = false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getOffers()
            },
            search() {
                this.page = 1;
                this.getOffers()
            }
        }
    }
</script>


<style scoped>

</style>